<template>
  <div>
    <DefaultNotification
    v-if="isOpen"
    @update-card="updateCard"
    @openCard="$emit('openCard', $event)"
    @close-notification="closeNotification"
    @toggle-today="toggleToday"
    @toggle-order="toggleOrder"
      :title="notification.title"
      :expand-text="notification.expandText"
      :notificationSwitch="true"
      :cards="cards"
      :viewedCards="viewedCards"
    />
  </div>
</template>

<script>
import DefaultNotification from '@/components/UI/notificacao/NotificacaoPadrao.vue'
import NotificationsCardRepository from '@/shared/http/repositories/crm/notificationscard.js'

export default {
  components: {
    DefaultNotification
  },
  mounted () {
    this.retrieveNotifications()
  },
  data () {
    return {
      notification:
      {
        title: 'Agenda',
        expandText: 'Visualizados'
      },
      cards: [],
      viewedCards: [],
      data: [],
      isOpen: true,
      today: false,
      asc: true
    }
  },
  methods: {
    closeNotification () {
      this.isOpen = false
    },
    formatDate (value) {
      if (value) {
        return this.moment(new Date(value)).tz('UTC').calendar()
      }
    },
    retrieveNotifications () {
      this.getViewed()
      this.getNotViewed()
    },
    getViewed () {
      let filteredData = []
      let params
      let order = this.asc ? 'asc' : 'desc'
      if (this.today) {
        params = `visualizado=true&agendamento=true&hoje=true&sort=card.cardDetails.agendamento,${order}`
      } else {
        params = `visualizado=true&agendamento=true&sort=card.cardDetails.agendamento,${order}`
      }
      NotificationsCardRepository.searchNotificationsUserCustom(params)
        .then(response => {
          if (response.data) {
            this.data = response.data.content
            this.data.forEach(element => {
              let card = {
                cardIcon: 'fas fa-calendar',
                cardIconText: this.formatDate(element.card.cardDetails.agendamento),
                cardPersonPic: '',
                cardTitle: element.card.nomePessoa,
                cardDescription: element.card.boardColumn.board.nome ? element.card.boardColumn.board.nome : element.card.boardColumn.nome,
                cardChecked: element.visualizado,
                cardObj: element
              }
              filteredData.push(card)
            })
          }
          this.viewedCards = filteredData
        })
        .catch(this.onException)
    },
    getNotViewed () {
      let filteredData = []
      let params
      let order = this.asc ? 'asc' : 'desc'
      // maybe getting only read
      if (this.today) {
        params = `visualizado=false&agendamento=true&hoje=true&sort=card.cardDetails.agendamento,${order}`
      } else {
        params = `visualizado=false&agendamento=true&sort=card.cardDetails.agendamento,${order}`
      }
      NotificationsCardRepository.searchNotificationsUserCustom(params)
        .then(response => {
          if (response.data) {
            this.data = response.data.content
            this.data.forEach(element => {
              let card = {
                cardIcon: 'fas fa-calendar',
                cardIconText: this.formatDate(element.card.cardDetails.agendamento),
                cardPersonPic: '',
                cardTitle: element.card.nomePessoa,
                cardDescription: element.card.boardColumn.board.nome ? element.card.boardColumn.board.nome : element.card.boardColumn.nome,
                cardChecked: element.visualizado,
                cardObj: element
              }
              filteredData.push(card)
            })
          }
          this.cards = filteredData
        })
        .catch(this.onException)
    },
    updateCard (card) {
      this.retrieveNotifications()
    },
    toggleToday () {
      this.today = !this.today
      this.retrieveNotifications()
    },
    toggleOrder () {
      this.asc = !this.asc
      this.retrieveNotifications()
    }
  },
  emits: ['update-card', 'close-notification', 'toggle-today', 'toggle-order']
}
</script>



// WEBPACK FOOTER //
// src/components/UI/notificacao/Agenda.vue